import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '@providers/api/api';


@Injectable()
export class Tracker {

  constructor(public api: Api) { }

  getCurrentLocation(params?:any){
    let req = this.api.get('index.php/activity/Tracker/tracker_location',params);
    return req;
  }

  getInterval(){
    let req = this.api.get('index.php/activity/Tracker/getInterval');
    return req;
  }

  update_location(params?:any){
    let req = this.api.post('index.php/activity/Tracker/update_location_employee',params);
    return req;
  }

  getAsset(params?:any){
    let req = this.api.get('index.php/activity/Tracker/data_asset',params);
    return req;
  }

  getHistorytAsset(params?:any){
    let req = this.api.get('index.php/activity/Tracker/history_asset',params);
    return req;
  }
  getRekapEmployeeLocation(params?:any){
    let req = this.api.get('index.php/activity/Tracker/rekap_employee',params);
    return req;
  }

  getEmployeeLocation(params?:any){
    let req = this.api.get('index.php/activity/Tracker/location_employee',params);
    return req;
  }
}


// WEBPACK FOOTER //
// ./src/providers/activity/tracker/provider.ts